module.exports = __webpack_public_path__ + "static/img/binanry.37e9f33.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/memes/binanry.jpg
// module id = eR34
// module chunks = 1